<template>
  <div>
    <v-container fluid>
      <v-card>
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Cadastro de Empresa</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary lighten-4 mr-2"
            @click="$router.go(-1)"
            :disabled="salvando"
          >Cancelar</v-btn>
          <v-btn
            depressed
            color="primary lighten-4"
            :disabled="!valid_loja"
            :loading="salvando"
            @click="salvar"
          >Salvar</v-btn>
        </v-app-bar>
        <v-form v-model="valid_loja" ref="form_loja" v-show="!loading">
          <v-container fluid>
            <v-row dense>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Razão Social"
                  v-model="loja.razao_social"
                  ref="razao_social"
                  @keypress.native.enter="$refs.nome_fantasia.focus()"
                  :rules="regras.loja.razao_social"
                  autofocus
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Nome Fantasia"
                  v-model="loja.nome_fantasia"
                  ref="nome_fantasia"
                  @keypress.native.enter="$refs.cnpj.focus()"
                  :rules="regras.loja.nome_fantasia"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="CNPJ"
                  v-model="loja.cnpj"
                  ref="cnpj"
                  @keypress.native.enter="$refs.ie.focus()"
                  v-mask="'##.###.###/####-##'"
                  :rules="regras.loja.cnpj"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Inscrição Estadual"
                  v-model="loja.ie"
                  ref="ie"
                  @keypress.native.enter="$refs.rua.focus()"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="Rua"
                  v-model="loja.endereco.rua"
                  ref="rua"
                  @keypress.native.enter="$refs.complemento.focus()"
                  :rules="regras.loja.endereco.rua"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  label="Complemento"
                  v-model="loja.endereco.complemento"
                  ref="complemento"
                  @keypress.native.enter="$refs.numero.focus()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-text-field
                  label="Número"
                  v-model="loja.endereco.numero"
                  ref="numero"
                  @keypress.native.enter="$refs.bairro.focus()"
                  :rules="regras.loja.endereco.numero"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  label="Bairro"
                  v-model="loja.endereco.bairro"
                  ref="bairro"
                  @keypress.native.enter="$refs.estado.focus()"
                  :rules="regras.loja.endereco.bairro"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6">
                <v-autocomplete
                  v-model="loja.endereco.estado_id"
                  :items="estados"
                  label="Estado"
                  ref="estado"
                  @change="getCidadesLoja"
                  @keypress.native.enter="$refs.cidade.focus()"
                  :rules="regras.loja.endereco.estado"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-autocomplete
                  v-model="loja.endereco.cidade_id"
                  :items="cidades"
                  label="Cidade"
                  ref="cidade"
                  @keypress.native.enter="$refs.cep.focus()"
                  :rules="regras.loja.endereco.cidade"
                  :loading="load_cidade_loja"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="2">
                <v-text-field
                  label="CEP"
                  v-model="loja.endereco.cep"
                  ref="cep"
                  @keypress.native.enter="$refs.telefone.focus()"
                  v-mask="'##.###-###'"
                  :rules="regras.loja.endereco.cep"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  label="Telefone"
                  v-model="loja.endereco.telefone"
                  ref="telefone"
                  @keypress.native.enter="$refs.celular.focus()"
                  v-mask="'(##) ####-####'"
                  :rules="regras.loja.endereco.telefone"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  label="Celular"
                  v-model="loja.endereco.celular"
                  ref="celular"
                  @keypress.native.enter="$refs.email.focus()"
                  v-mask="'(##) #####-####'"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="Email"
                  v-model="loja.endereco.email"
                  ref="email"
                  @keypress.native.enter="salvar"
                  :rules="regras.loja.endereco.email"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>
    </v-container>
    <v-layout v-show="loading" justify-center align-center mt-5>
      <v-progress-circular indeterminate size="50" width="3" color="primary"></v-progress-circular>
    </v-layout>
  </div>
</template>

<script>
import ServiceLojas from "@/services/lojas.js";
import Services from "@/services/services.js";
import validadores from "@/mixins/validadores-mixin";

export default {
  name: "LojasForm",
  mixins: [validadores],
  data() {
    return {
      loading: false,
      salvando: false,
      user: {},
      loja: {
        id: "",
        cliente_id: "",
        endereco_id: "",
        cnpj: "",
        ie: "",
        nome_fantasia: "",
        razao_social: "",
        responsavel_id: "",
        logo: "",
        endereco: {
          id: "",
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade_id: "",
          estado_id: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
        },
      },
      estados: Services.estados(),
      cidades: [],
      tab: 0,
      valid_loja: true,
      regras: {
        loja: {
          razao_social: [(value) => !!value || "Campo obrigatório"],
          nome_fantasia: [(value) => !!value || "Campo obrigatório"],
          cnpj: [
            (value) => !!value || "Campo obrigatório",
            (value) => this.validarCNPJ(value) || "CNPJ inválido",
          ],
          endereco: {
            rua: [(value) => !!value || "Campo obrigatório"],
            numero: [(value) => !!value || "Campo obrigatório"],
            bairro: [(value) => !!value || "Campo obrigatório"],
            estado: [(value) => !!value || "Campo obrigatório"],
            cidade: [(value) => !!value || "Campo obrigatório"],
            cep: [
              (value) => !!value || "Campo obrigatório",
              (value) => value.length > 7 || "CEP inválido",
            ],
            telefone: [(value) => !!value || "Campo obrigatório"],
            email: [
              (value) => !!value || "Campo obrigatório",
              (value) => this.validarEmail(value) || "E-mail inválido",
            ],
          },
        },
      },
      load_cidade_loja: false,
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.$route.params.id) {
      this.editar();
    }
  },
  methods: {
    async editar() {
      try {
        this.loading = true;
        let response = await ServiceLojas.editar(
          this.user.cliente_id,
          this.$route.params.id
        );
        this.loja = response.data.loja;
        this.getCidadesLoja();
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao listar empresa");
      } finally {
        this.loading = false;
      }
    },
    async salvar() {
      try {
        this.salvando = true;
        if (this.$refs.form_loja.validate()) {
          if (this.$route.params.id) {
            await ServiceLojas.atualizar(this.user.cliente_id, this.loja);
          } else {
            await ServiceLojas.salvar(this.user.cliente_id, this.loja);
          }
          this.$eventbus.notificar("Empresa salva com sucesso");
          this.$router.go(-1);
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro(error.response.data.msg);
      } finally {
        this.salvando = false;
      }
    },
    async getCidadesLoja() {
      try {
        this.load_cidade_loja = true;
        let response = await Services.cidades(this.loja.endereco.estado_id);
        this.cidades = response.data.cidades;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao listar lojas");
      } finally {
        this.load_cidade_loja = false;
      }
    },
  },
};
</script>

<style>
.erro {
  color: red;
}
</style>
